<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-3" lang="en-GB"><a id="_idTextAnchor003"></a>Putting Up with Caroline</h1>
<p class="Verse-first" lang="en-GB">Caroline is my paradigm</p>
<p class="Verse-main" lang="en-GB">She sits beside me,</p>
<p class="Verse-main" lang="en-GB">And her legs are better than mine.</p>
<p class="Verse-main" lang="en-GB">I watch her as she watches,</p>
<p class="Verse-main" lang="en-GB">Our cat sits on her lap.</p>
<p class="Verse-main" lang="en-GB">The cat prefers Caroline.</p>
<p class="Verse-new" lang="en-GB">Caroline in all her finest glory,</p>
<p class="Verse-main" lang="en-GB">Sits, shaven legs.</p>
<p class="Verse-main" lang="en-GB">Her hair shiny from L’Oréal.</p>
<p class="Verse-main" lang="en-GB">Mine a dull brown.</p>
<p class="Verse-main" lang="en-GB">I’m too tired to attend to mine,</p>
<p class="Verse-main" lang="en-GB">yet Caroline, puts hers in place.</p>
<p class="Verse-main" lang="en-GB">Even as she watches the latest case.</p>
<p class="Verse-new" lang="en-GB">Do I love her?</p>
<p class="Verse-main" lang="en-GB">I don’t know.</p>
<p class="Verse-main" lang="en-GB">I don’t even remember.</p>
<p class="Verse-main" lang="en-GB">A time to remember when she was my husband.</p>
<p class="Verse-main" lang="en-GB">Her perfume is mine,</p>
<p class="Verse-main" lang="en-GB">her shoes too big.</p>
<p class="Verse-main" lang="en-GB">Where did she get those anyway?</p>
<p class="Verse-main" lang="en-GB">And tomorrow,</p>
<p class="Verse-main" lang="en-GB">She will be Dave to her friends.</p>
<p class="Verse-main" lang="en-GB">And I will have to keep her secret.</p>
<p class="Verse-main" lang="en-GB">But I like her,</p>
<p class="Verse-main" lang="en-GB">I want to keep her,</p>
<p class="Verse-main" lang="en-GB">She is my Caroline.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398432048_EPUB7.vue?1b8d8aa8